let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lbMTW")).then(() => parcelRequire('k1LfU'));